function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNestLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300px",
    height: "96px",
    viewBox: "0 0 300 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.835938 30.503906 C 42.949219 39.046875 30.949219 42.035156 29.855469 54.601562 C 29.59375 57.660156 31.164062 58.679688 27.3125 56.832031 C 16.066406 51.457031 24.515625 35.746094 33.3125 31.378906 C 42.109375 27.011719 46.453125 26.316406 53.664062 18.875 C 54.300781 18.214844 55.105469 15.972656 54.949219 18.804688 C 54.730469 22.765625 52.285156 27.457031 49.835938 30.492188 Z M 49.835938 30.503906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(68.235296%,69.411767%,70.19608%)",
      fillOpacity: 1
    },
    d: "M 62.242188 30.40625 C 62.449219 30.492188 64.355469 33.671875 64.546875 34.066406 C 71.785156 48.804688 58.871094 59.554688 46.199219 64.019531 C 37.871094 66.949219 28.140625 66.839844 20.050781 63.179688 L 25.859375 63.253906 C 40.222656 64.042969 62.472656 52.476562 62.542969 35.902344 C 62.542969 34.65625 61.753906 31.222656 61.800781 30.769531 C 61.824219 30.539062 62.003906 30.300781 62.242188 30.40625 Z M 62.242188 30.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(41.960785%,43.137255%,44.313726%)",
      fillOpacity: 1
    },
    d: "M 10.859375 30.265625 C 11.050781 30.492188 9.996094 35.269531 9.960938 36.214844 C 9.515625 48.058594 19.824219 56.410156 29.878906 60.191406 C 30.371094 60.371094 33.238281 60.5625 31.429688 61.320312 C 30.671875 61.644531 26.304688 61.535156 25.246094 61.453125 C 11.113281 60.324219 0.9375 49.511719 7.261719 35.171875 C 7.453125 34.753906 10.320312 29.628906 10.859375 30.253906 Z M 10.859375 30.265625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.490197%,92.156863%,97.647059%)",
      fillOpacity: 1
    },
    d: "M 67.753906 56.183594 C 63.996094 73.789062 46.007812 84.863281 28.644531 80.820312 C 22.140625 79.308594 15.3125 75.46875 11.472656 70.042969 C 19.980469 75.179688 31.078125 76.90625 39.949219 71.628906 C 39.660156 71.53125 39.214844 71.664062 38.890625 71.699219 C 33.683594 72.394531 30.910156 73.273438 25.429688 72.574219 C 17.964844 71.640625 9.382812 68.304688 6.085938 61.03125 C 5.410156 59.554688 3.277344 51.792969 4.078125 50.746094 C 4.261719 50.519531 6.492188 54.839844 6.816406 55.320312 C 13.273438 64.644531 30.15625 70.523438 41.148438 68.832031 C 52.261719 67.117188 62.808594 60 67.066406 49.464844 C 67.222656 49.066406 67.957031 45.421875 68.425781 46.777344 C 68.902344 48.191406 68.113281 54.421875 67.738281 56.160156 Z M 67.753906 56.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.421875 15.394531 C 44.230469 19.800781 36.984375 33.046875 28.777344 27.335938 C 21.851562 22.523438 28.246094 10.777344 36.421875 15.394531 Z M 36.421875 15.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.128906 77.242188 L 82.128906 23.664062 L 114.277344 23.664062 C 117.226562 23.664062 119.746094 24.71875 121.8125 26.84375 C 123.9375 28.96875 124.992188 31.476562 124.992188 34.378906 L 124.992188 77.242188 L 114.277344 77.242188 L 114.277344 34.378906 L 92.84375 34.378906 L 92.84375 77.242188 Z M 82.128906 77.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 153.457031 77.242188 C 150.445312 77.242188 147.898438 76.210938 145.835938 74.148438 C 143.773438 72.023438 142.738281 69.492188 142.738281 66.527344 L 142.738281 34.378906 C 142.738281 31.429688 143.773438 28.90625 145.835938 26.84375 C 147.960938 24.71875 150.492188 23.664062 153.457031 23.664062 L 185.605469 23.664062 L 185.605469 34.378906 L 153.457031 34.378906 L 153.457031 45.097656 L 185.605469 45.097656 L 185.605469 55.8125 L 153.457031 55.8125 L 153.457031 66.527344 L 185.605469 66.527344 L 185.605469 77.242188 Z M 153.457031 77.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 203.339844 77.242188 L 203.339844 66.527344 L 235.488281 66.527344 L 235.488281 55.8125 L 214.054688 55.8125 C 211.042969 55.8125 208.5 54.78125 206.4375 52.714844 C 204.371094 50.59375 203.339844 48.058594 203.339844 45.097656 L 203.339844 34.378906 C 203.339844 31.429688 204.371094 28.90625 206.4375 26.84375 C 208.558594 24.71875 211.09375 23.664062 214.054688 23.664062 L 246.203125 23.664062 L 246.203125 34.378906 L 214.054688 34.378906 L 214.054688 45.097656 L 235.488281 45.097656 C 238.441406 45.097656 240.960938 46.152344 243.023438 48.277344 C 245.148438 50.398438 246.203125 52.90625 246.203125 55.8125 L 246.203125 66.527344 C 246.203125 69.539062 245.148438 72.085938 243.023438 74.148438 C 240.898438 76.210938 238.390625 77.242188 235.488281 77.242188 Z M 203.339844 77.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 274.667969 77.242188 L 274.667969 34.378906 L 263.953125 34.378906 L 263.953125 23.664062 L 296.101562 23.664062 L 296.101562 34.378906 L 285.382812 34.378906 L 285.382812 77.242188 Z M 274.667969 77.242188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestLogoNew);
export default __webpack_public_path__ + "static/media/NEST_LOGO_NEW.adc8c62c7a03e31fbdb29663e07ebabb.svg";
export { ForwardRef as ReactComponent };